import transitions from "@ecco/ui/tokens/transitions";

export const baseImageBox = {
    cursor: "pointer",
    bg: "gray.100",
    width: 12,
    borderColor: "transparent",
    overflow: "hidden",
    aspectRatio: "4/5",
    position: "relative",
    display: "block",
    transition: `opacity ${transitions.duration.fast} ${transitions.easing["ease-out"]}`,
};

export const getImageBoxStyles = (isSelected: boolean, isLoading: boolean) => ({
    ...baseImageBox,
    _after: {
        content: '""',
        display: "block",
        boxSizing: "border-box",
        width: "100%",
        height: "100%",
        position: "absolute",
        top: 0,
        left: 0,
        opacity: isSelected ? 1 : 0,
        pointerEvents: "none",
        border: "1px solid",
        borderColor: "black",
        transition: `opacity ${transitions.duration.fast} ${transitions.easing["ease-out"]}`,
    },
    ...(isLoading && {
        opacity: 0.5,
        pointerEvents: "none",
        cursor: "wait",
    }),
});
